/////////////////////////////////// PRODUCT-TAB-BLOCK
document.addEventListener('DOMContentLoaded', () => {
  // Find ALL view-all buttons (one per section)
  const viewAllButtons = document.querySelectorAll('.viewallbtn.dynamic-viewall');

  viewAllButtons.forEach((viewAllButton) => {
    // Find the closest product-tab section container for this button
    const sectionContainer = viewAllButton.closest('.halo-product-block, .product-tab-block, .section-block');

    if (!sectionContainer) return;

    // Only look for tabs/buttons inside THIS section
    const tabButtons = sectionContainer.querySelectorAll('.list-product-tabs .tab-links');

    const updateViewAllHref = () => {
      const activeTab = sectionContainer.querySelector('.list-product-tabs .tab-links.active');
      if (activeTab && viewAllButton) {
        const href = activeTab.getAttribute('data-href').replace('?view=ajax_product_block', '');
        viewAllButton.setAttribute('href', href);
      }
    };

    // Run once on load
    updateViewAllHref();

    // Listen to clicks inside this section only
    tabButtons.forEach(button => {
      button.addEventListener('click', updateViewAllHref);
    });

    // Observe class changes only on tabs inside this section
    const observer = new MutationObserver(updateViewAllHref);
    tabButtons.forEach(button => {
      observer.observe(button, { attributes: true, attributeFilter: ['class'] });
    });

    // Optional: store per-section if you need cleanup later
    // sectionContainer.__tabObserver = observer;
  });
});

/////////////////////////////////////////////////// COLLECTION-PRODUCT-GRID


document.addEventListener('DOMContentLoaded', () => {
  const sidebar = document.getElementById('halo-sidebar');
  const pageContent = document.querySelector('.page-sidebar + .page-content');
  
  const isMobile = window.innerWidth <= 749;
  let isSidebarVisible = !isMobile;

  if (isMobile) {
    sidebar.style.display = 'none';
    pageContent.classList.add('full-width');
  }

  document.querySelectorAll('.hide-sidebar-btn').forEach(btn => {
    const arrow = btn.querySelector('.hide-sidebar-btn-arrow');
    
    btn.addEventListener('click', () => {
      if (isSidebarVisible) {
        // Hide
        sidebar.style.display = 'none';
        pageContent.classList.add('full-width');
        isSidebarVisible = false;
        arrow?.classList.add('flipped');
      } else {
        // Show
        sidebar.style.display = 'block';
        pageContent.classList.remove('full-width');
        isSidebarVisible = true;
        arrow?.classList.remove('flipped');
      }
    });
  });
});


////////////////////////////////////////////// TOOLBAR .LIQUID
document.addEventListener('DOMContentLoaded', function() {
  const countersrise = document.querySelectorAll('.counterrise');
  
  function startCountingrise(element) {
    let start = 0;
    const end = parseInt(element.getAttribute('data-count')) || 0;
    const duration = 2000;
    const range = end - start;
    let current = start;
    const increment = end > start ? 1 : -1;
    const stepTime = Math.abs(Math.floor(duration / range)) || 1;
    
    const timer = setInterval(() => {
      current += increment;
      element.textContent = current;
      if (current === end) clearInterval(timer);
    }, stepTime);
    
    element.classList.add('animaterise');
  }

  function checkCountersrise() {
    countersrise.forEach(counterrise => {
      const rect = counterrise.getBoundingClientRect();
      if (rect.top <= window.innerHeight && rect.bottom >= 0 && !counterrise.classList.contains('animaterise')) {
        startCountingrise(counterrise);
      }
    });
  }

  // Save reference for cleanup
  window.__counterScrollHandler = checkCountersrise;
  window.addEventListener('scroll', checkCountersrise);
  checkCountersrise();
});


//////////////////////////////// HALO-QUICK-VIEW-SLICK SLIDER///////////////////////////

let quickzerObserver = null;

function initquickzer(quickzer) {
    let isDown = false;
    let startX;
    let scrollLeft;
    const sensitivity = 1.5;

    function removeEventListeners() {
        quickzer.removeEventListener('mousedown', handleStart);
        quickzer.removeEventListener('mouseleave', handleEnd);
        quickzer.removeEventListener('mouseup', handleEnd);
        quickzer.removeEventListener('mousemove', handleMove);
    }

    function handleStart(e) {
        isDown = true;
        quickzer.classList.add('grabbing');
        startX = e.pageX - quickzer.offsetLeft;
        scrollLeft = quickzer.scrollLeft;
    }

    function handleEnd() {
        isDown = false;
        quickzer.classList.remove('grabbing');
    }

    function handleMove(e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - quickzer.offsetLeft;
        const walk = (x - startX) * sensitivity;
        quickzer.scrollLeft = scrollLeft - walk;
    }

    removeEventListeners();
    quickzer.addEventListener('mousedown', handleStart);
    quickzer.addEventListener('mouseleave', handleEnd);
    quickzer.addEventListener('mouseup', handleEnd);
    quickzer.addEventListener('mousemove', handleMove);
}

function isDesktopView() {
    return window.innerWidth > 768;
}

if (isDesktopView()) {
    quickzerObserver = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    const quickzers = node.querySelectorAll('.quickzer-container:not([data-initialized])');
                    quickzers.forEach(quickzer => {
                        initquickzer(quickzer);
                        quickzer.dataset.initialized = 'true';
                    });
                }
            });
        });
    });

    const container = document.querySelector('.halo-quick-view-popup') || document.body;
    quickzerObserver.observe(container, { childList: true, subtree: true }); // subtree needed for quick-view

    // Initial
    document.querySelectorAll('.quickzer-container:not([data-initialized])').forEach(quickzer => {
        initquickzer(quickzer);
        quickzer.dataset.initialized = 'true';
    });
}

window.addEventListener('beforeunload', () => quickzerObserver?.disconnect());



///////////////////////////////////////// CLEANUP: Remove all global listeners and observers on page unload
window.addEventListener('beforeunload', () => {
  // Product Tab Observer
  window.__productTabObserver?.disconnect();

  // Counter Scroll
  if (window.__counterScrollHandler) {
    window.removeEventListener('scroll', window.__counterScrollHandler);
    window.__counterScrollHandler = null;
  }

  // quickzer Observer
  quickzerObserver?.disconnect();
});






//////////////////////////////////////// =========================================THEME.LIQUID JS



  /////////////START SCRIPT
  document.addEventListener('DOMContentLoaded', function() {
    const quickShopSwatches = document.querySelectorAll('.variants-popup-content .swatch-element');
    
    quickShopSwatches.forEach(swatch => {
      swatch.addEventListener('click', function() {
        const variantImg = this.getAttribute('data-variant-img');
        const productId = this.closest('.variants-popup-content').querySelector('form').dataset.id.replace('product-actions-', '');
        const productCard = document.querySelector(`.product-item[data-product-id="${productId}"]`);
        
        if (variantImg && productCard) {
          const cardImage = productCard.querySelector('.card-media img');
          if (cardImage) {
            cardImage.src = variantImg;
            cardImage.srcset = variantImg; // Update srcset for responsive images
          }
        }
      });
    });
  });
/////////////END SCRIPT




////////////////////// RIPPLE BUTTON EFFECT
let rippleObserver = null;

function initRipple() {
  document.querySelectorAll('.rip-btn:not([data-ripple])').forEach(btn => {
    btn.dataset.ripple = 'true';
    btn.addEventListener('click', rippleHandler);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initRipple();
  rippleObserver = new MutationObserver(initRipple);
  rippleObserver.observe(document.body, { childList: true, subtree: false }); // Narrowed
});

window.addEventListener('beforeunload', () => rippleObserver?.disconnect());





// Your original handler
function rippleHandler(e) {
  let x = e.offsetX;
  let y = e.offsetY;
  const ripple = document.createElement('span');
  ripple.classList.add('ripple');
  ripple.style.setProperty('--mouse-x', x + 'px');
  ripple.style.setProperty('--mouse-y', y + 'px');
  this.appendChild(ripple);
  setTimeout(() => ripple.classList.add('fade-out'), 0);
  setTimeout(() => ripple.remove(), 3000);
}




/*
<script>
  // Handle add-to-cart events
$(document).on('click', '[data-btn-addtocart]', function(e) {
    e.preventDefault();
    var $this = $(this);
    var $form = $this.closest('form');
    
    var variantId = $form.find('[name="id"]').val();
    var quantity = parseInt($form.find('[name="quantity"]').val()) || 1;
    var size = $form.find('input[name="properties[Size]"]:checked').val() || '';

    var payload = { id: variantId, quantity: quantity };
    if (size) payload.properties = { Size: size };

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(payload),
        contentType: '',
        success: function() {
            updateCartTotal();
            document.dispatchEvent(new Event('cart:updated'));
        }
    });
});
</script>*/




document.addEventListener('click', e => {
  const btn = e.target.closest('[data-open-edit-cart]');
  if (!btn) return;

  const line = btn.dataset.line;
  const observer = new MutationObserver(() => {
    const item = document.querySelector('.product-edit-item');
    if (item) {
      item.dataset.line = line;
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});








    document.querySelectorAll('.scrollable-title').forEach(el => {
    let isDown = false;
    let startX;
    let scrollLeft;

    // Mouse drag
    el.addEventListener('mousedown', e => {
      isDown = true;
      el.classList.add('active');
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
    });

    el.addEventListener('mouseleave', () => {
      isDown = false;
      el.classList.remove('active');
    });

    el.addEventListener('mouseup', () => {
      isDown = false;
      el.classList.remove('active');
    });

    el.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      const walk = (x - startX) * 2; // Multiply for speed
      el.scrollLeft = scrollLeft - walk;
    });

    // Bonus: Horizontal scroll with vertical wheel (Shift + Wheel or natural)
    el.addEventListener('wheel', e => {
      if (e.deltaY !== 0) {
        el.scrollLeft += e.deltaY;
        e.preventDefault(); // Prevent page scroll
      }
    });
  });








  //////////////////////////// ←←← FINAL VERSION – copy-paste this exactly
let startY = 0;
const cart = document.getElementById('halo-cart-sidebar');
const closeBtn = document.querySelector('[data-close-cart-sidebar]');

cart.addEventListener('touchstart', e => {
  if (e.target.closest('.swipe-handle')) {
    startY = e.touches[0].clientY;
  }
}, { passive: true });

cart.addEventListener('touchmove', e => {
  if (!startY) return;
  const currentY = e.touches[0].clientY;
  const pulledDown = currentY - startY;

  // Optional: tiny visual feedback (rubber-band effect)
  if (pulledDown > 0) {
    cart.style.transform = `translateY(${Math.min(pulledDown * 0.3, 80)}px)`; // very subtle
  }
  e.preventDefault();
}, { passive: false });

cart.addEventListener('touchend', () => {
  if (!startY) return;

  const pulledDown = event.changedTouches[0].clientY - startY;

  // Remove any temporary transform
  cart.style.transform = '';

  if (pulledDown > 140) {
    // Simply click your real close button → Halo handles everything perfectly
    closeBtn.click();
  }

  startY = 0;
});







/*
<script>
// STAND-ALONE LEFT MENU – SWIPE LEFT TO CLOSE (co-exists with cart pull-down)
// Works on any Halo theme menu that slides in from the left
(() => {
  let startX = 0;
  const menu = document.querySelector('.halo-sidebar.halo-sidebar_menu');
  if (!menu) return; // safety

  const closeButtons = menu.querySelectorAll('[data-menu-close-sidebar]');
  const closeMenu = () => closeButtons.forEach(btn => btn.click());

  menu.addEventListener('touchstart', e => {
    if (e.target.closest('.swipe-handle') || e.target.closest('.halo-sidebar-header')) {
      startX = e.touches[0].clientX;
    }
  }, { passive: true });

  menu.addEventListener('touchmove', e => {
    if (!startX) return;
    const currentX = e.touches[0].clientX;
    const pulledLeft = startX - currentX; // positive = swiped left

    // Optional subtle rubber-band feedback while dragging
    if (pulledLeft > 0) {
      menu.style.transform = `translateX(-${Math.min(pulledLeft * 0.4, 100)}px)`;
    }
    e.preventDefault();
  }, { passive: false });

  menu.addEventListener('touchend', () => {
    if (!startX) return;

    const pulledLeft = startX - event.changedTouches[0].clientX;

    // Clean up any temporary transform
    menu.style.transform = '';

    if (pulledLeft > 130) {
      closeMenu(); // triggers your exact existing close button → perfect Halo animation
    }

    startX = 0;
  });
})();
</script>
*/









/////////////////////////////// PRODUCT CARD COLOR NAME FOR MOBILE///////////////////

function initSwatchOverlays() {
  document.querySelectorAll('.card-swatch .swatch-label:not([data-overlay-init])').forEach(label => {
    const card = label.closest('.card-wrapper, .grid__item, .product-card, [data-product-id]');
    if (!card) return;

    const overlay = card.querySelector('.color-name-overlay');
    if (!overlay) return;

    label.setAttribute('data-overlay-init', 'true');

    const showOverlay = () => {
      overlay.textContent = label.dataset.colorName;
      overlay.style.opacity = '1';
      clearTimeout(overlay.hideTimeout);
      overlay.hideTimeout = setTimeout(() => overlay.style.opacity = '0', 1800);
    };

    label.addEventListener('touchstart', showOverlay, { passive: true });
    label.addEventListener('click', showOverlay);
  });
}

document.addEventListener('DOMContentLoaded', initSwatchOverlays);
document.addEventListener('shopify:section:load', initSwatchOverlays);








let scrollTimer;
function checkCountersrise() {
  if (scrollTimer) return;
  scrollTimer = setTimeout(() => {
    document.querySelectorAll('.counterrise:not(.animaterise)').forEach(counter => {
      const rect = counter.getBoundingClientRect();
      if (rect.top <= window.innerHeight && rect.bottom >= 0) {
        startCountingrise(counter);
      }
    });
    scrollTimer = null;
  }, 100);
}

document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener('scroll', checkCountersrise, { passive: true });
  checkCountersrise();
});










document.addEventListener('click', e => {
  if (!e.target.closest('.previewCart-wrapper button, [data-open-quick-view-popup]')) return;
  if (!document.body.classList.contains('cart-sidebar-show')) return;

  setTimeout(() => {
    const modal = document.querySelector('.halo-popup.halo-quick-view-popup.customPopup-large');
    if (modal) modal.style.setProperty('z-index', '106', 'important');
  }, 200);
}, true);







document.addEventListener('DOMContentLoaded', function() {
  const toggleBtn = document.querySelector('.simple-cart-toggle');
  const cartIcon = toggleBtn?.querySelector('.cart-icon');
  const closeIcon = toggleBtn?.querySelector('.close-icon');

  if (!toggleBtn || !cartIcon || !closeIcon) return;

  function isOpen() {
    return document.body.classList.contains('cart-sidebar-show');
  }

  function updateIcon() {
    if (isOpen()) {
      cartIcon.style.opacity = '0';
      closeIcon.style.opacity = '1';
    } else {
      cartIcon.style.opacity = '1';
      closeIcon.style.opacity = '0';
    }
  }

  // Prevent any external script from disabling the button visually
  const buttonObserver = new MutationObserver(() => {
    if (toggleBtn.hasAttribute('disabled')) {
      toggleBtn.removeAttribute('disabled');
    }
  });
  buttonObserver.observe(toggleBtn, { attributes: true, attributeFilter: ['disabled'] });

  // Initial state
  updateIcon();

  // Click
  toggleBtn.addEventListener('click', function(e) {
    // If theme JS prevents default or disables, counteract it
    document.body.classList.toggle('cart-sidebar-show');
    updateIcon();
  });

  // Sync with other triggers
  const bodyObserver = new MutationObserver(updateIcon);
  bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
});





